export const HELP_QUESTIONS_CONVERT = [
  {
    title: "آیا کارمزد Convert Trade متفاوت است؟",
    answer: `
    بله، به دلیل اینکه شما در حال تبدیل ارزهای دیجیتال و تومان به
    تتر در پلتفرم <span class="blue-text">OTC</span> ساناکش می
    باشید و در این قسمت محدودیتی برای مبادلات وجود ندارد، ما در این
    پلتفرم کارمزدهای متفاوتی خواهیم داشت که بیشتر از کارمزد
    <span class="blue-text">Trade</span> خواهد بود.
    <br /> سیستم به صورت اتومات برای شما محاسبه و سپس اعلام خواهد
    کرد که برای تبدیل هر ارز چه مقدار ارز مقابل را بدست خواهید آورد
    که این عدد قطعی و با محاسبه کارمزد می باشد.
  `,
  },
  {
    title: "چه زمانی از Convert Trade استفاده کنم؟",
    answer: `
      اگر شما نیاز داشته باشید که تمام موجودی ولت خود را به ارز تتر و
      یا بالعکس تبدیل کنید که در قسمت
      <span class="blue-text">Trade</span> با توجه به محدودیت رقم
      اعشار و حداقل مبادلات قابل تبدیل نمی باشد می توانید تمام موجودی
      خود را به ارز مقابل بدون هیچ محدودیتی و البته با کارمزد بالاتر،
      تبدیل کنید.
      <br /> توجه داشته باشید که فقط موجودی
      <span class="blue-text">Spot</span>
      <span class="blue-text">Wallet</span> شما قابل
      <span class="blue-text">Convert</span><br /> می باشد.
    `,
  },
];

export const CONVERT_MOBILE_HELP = {
  title: "راهنمای Convert",
  description: ` 
  <span class="blue-text n-weight-500">Convert Trade چیست ؟</span>
  <br>
  <small>
  تبدیل ارزهای دیجیتال و تومان به تتر و بالعکس بدون محدودیت تا 8 رقم اعشار
  </small>
  <br>
  <br>
  <span class="blue-text n-weight-500">آیا کارمزد Convert Trade متفاوت است ؟</span>
  <br>
  <small>
  بله ، به دلیل اینکه شما در حال تبدیل ارزهای دیجیتال و تومان به تتر در پلتفرم OTC ساناکش می باشید و دراین قسمت محدودیتی برای مبادلات وجود ندارد، ما دراین پلتفرم کارمزدهای متفاوتی خواهیم داشت که بیشتراز کارمزد Trade خواهد بود ، سیستم بطور اتومات برای شما محاسبه خواهد کرد و به شما اعلام میکنیم که برای تبدیل هر ارز چه مقدار ارز مقابل را بدست خواهید آورد که این عدد قطعی و با محاسبه کارمزد میباشد.
  </small>
  <br>
  <br>
  <span class="blue-text n-weight-500">چه زمانی از Convert Trade استفاده کنم ؟</span>
  <br>
  <small>
  اگر شما نیاز داشته باشید که تمام موجودی ولت خود را به ارز تتر و یا بالعکس تبدیل کنید که در قسمت Trade با توجه به محدودیت رقم اعشار و حداقل مبادلات قابل تبدیل نمی باشد می توانید تمام موجودی خود را به ارز مقابل بدون هیچ محدودیتی و البته با کارمزد بالاتر، تبدیل کنید . توجه داشته باشید که فقط موجودی Spot Wallet  شما قابل Convert می باشد
  </small>
  `,
};
